import { useMemo } from 'react';
import { useSiteSettings } from '../hooks/useContent';
import { usePageSeo } from '../hooks/usePageSeo';
import { buildBreadcrumbSchema, buildOrganizationSchema } from '../utils/seo';
import { parseInitiativesCards } from '../utils/siteSettingsJson';
import './Initiatives.css';

const Initiatives = () => {
  const { settings } = useSiteSettings();
  const brand = settings.site_brand_name || 'Invincible NGO';
  const publicBase =
    String(settings.site_public_url || '').replace(/\/$/, '') ||
    (typeof window !== 'undefined' ? window.location.origin : '');
  const pageTitle = settings.initiatives_hero_title || 'Our Initiatives';
  const pageSubtitle = settings.initiatives_hero_subtitle || 'Making a positive impact';
  const cards = parseInitiativesCards(settings.initiatives_cards);

  const initiativesSchema = useMemo(() => {
    const org = buildOrganizationSchema(settings);
    const breadcrumbs = buildBreadcrumbSchema([
      { name: 'Our Initiatives', url: '/initiatives' }
    ], publicBase);
    return {
      '@context': 'https://schema.org',
      '@graph': [org, breadcrumbs]
    };
  }, [settings, publicBase]);

  usePageSeo({
    title: `${pageTitle} | ${brand}`,
    description: pageSubtitle || settings.site_meta_description,
    canonical: publicBase ? `${publicBase}/initiatives` : undefined,
    schema: initiativesSchema
  });


  return (
    <div className="initiatives-page">
      <div className="page-header">
        <h1 className="page-title">{pageTitle}</h1>
        <p className="page-subtitle">{pageSubtitle}</p>
      </div>

      <div className="initiatives-content">
        {cards.map((card) => (
          <div className="initiative-card" key={card.title}>
            <h2>{card.title}</h2>
            <p>{card.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Initiatives;
